/* ******************** NPM ******************** */
// Use following imports only where needed (not globally)
// Bootstrap modules (add as needed)
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/carousel";

/* ******************** BASE ******************** */
// Import utilities as needed
import {
    utl_keyboardFocusMode,
    utl_setFooterYear,
    utl_handleModalClose,
    utl_ehElements,
    utl_anchorScrollOffset,
    // utl_toggleCookiesAlert,
} from "./base/_utils.js";

// Call utility functions after imported
utl_keyboardFocusMode();
utl_setFooterYear();
utl_handleModalClose;
utl_anchorScrollOffset();
utl_ehElements();
// utl_toggleCookiesAlert();

/* ******************** COMPONENTS ******************** */
import navigationInit from "./components/_navigation.js";
import carouselsInit from "./components/_carousels";

navigationInit();
carouselsInit();

/* ******************** PAGES ******************** */
// Individual page scripts are added in the header of specific page's index file
